module.exports = __webpack_public_path__ + "static/media/ok.e94562bc.svg";